/**
 * @fileoverview gRPC-Web generated client stub for api
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.20.3
// source: api.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.api = require('./api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.AuthServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.AuthServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.LoginRequest,
 *   !proto.api.LoginResponse>}
 */
const methodDescriptor_AuthService_Login = new grpc.web.MethodDescriptor(
  '/api.AuthService/Login',
  grpc.web.MethodType.UNARY,
  proto.api.LoginRequest,
  proto.api.LoginResponse,
  /**
   * @param {!proto.api.LoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.LoginResponse.deserializeBinary
);


/**
 * @param {!proto.api.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.LoginResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.LoginResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.AuthServiceClient.prototype.login =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.AuthService/Login',
      request,
      metadata || {},
      methodDescriptor_AuthService_Login,
      callback);
};


/**
 * @param {!proto.api.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.LoginResponse>}
 *     Promise that resolves to the response
 */
proto.api.AuthServicePromiseClient.prototype.login =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.AuthService/Login',
      request,
      metadata || {},
      methodDescriptor_AuthService_Login);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.RefreshRequest,
 *   !proto.api.RefreshResponse>}
 */
const methodDescriptor_AuthService_Refresh = new grpc.web.MethodDescriptor(
  '/api.AuthService/Refresh',
  grpc.web.MethodType.UNARY,
  proto.api.RefreshRequest,
  proto.api.RefreshResponse,
  /**
   * @param {!proto.api.RefreshRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.RefreshResponse.deserializeBinary
);


/**
 * @param {!proto.api.RefreshRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.RefreshResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.RefreshResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.AuthServiceClient.prototype.refresh =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.AuthService/Refresh',
      request,
      metadata || {},
      methodDescriptor_AuthService_Refresh,
      callback);
};


/**
 * @param {!proto.api.RefreshRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.RefreshResponse>}
 *     Promise that resolves to the response
 */
proto.api.AuthServicePromiseClient.prototype.refresh =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.AuthService/Refresh',
      request,
      metadata || {},
      methodDescriptor_AuthService_Refresh);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.UserServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.UserServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListUsersRequest,
 *   !proto.api.ListUsersResponse>}
 */
const methodDescriptor_UserService_ListUsers = new grpc.web.MethodDescriptor(
  '/api.UserService/ListUsers',
  grpc.web.MethodType.UNARY,
  proto.api.ListUsersRequest,
  proto.api.ListUsersResponse,
  /**
   * @param {!proto.api.ListUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListUsersResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.UserServiceClient.prototype.listUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.UserService/ListUsers',
      request,
      metadata || {},
      methodDescriptor_UserService_ListUsers,
      callback);
};


/**
 * @param {!proto.api.ListUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListUsersResponse>}
 *     Promise that resolves to the response
 */
proto.api.UserServicePromiseClient.prototype.listUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.UserService/ListUsers',
      request,
      metadata || {},
      methodDescriptor_UserService_ListUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.SaveUserRequest,
 *   !proto.api.SaveUserResponse>}
 */
const methodDescriptor_UserService_CreateUser = new grpc.web.MethodDescriptor(
  '/api.UserService/CreateUser',
  grpc.web.MethodType.UNARY,
  proto.api.SaveUserRequest,
  proto.api.SaveUserResponse,
  /**
   * @param {!proto.api.SaveUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.SaveUserResponse.deserializeBinary
);


/**
 * @param {!proto.api.SaveUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.SaveUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.SaveUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.UserServiceClient.prototype.createUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.UserService/CreateUser',
      request,
      metadata || {},
      methodDescriptor_UserService_CreateUser,
      callback);
};


/**
 * @param {!proto.api.SaveUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.SaveUserResponse>}
 *     Promise that resolves to the response
 */
proto.api.UserServicePromiseClient.prototype.createUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.UserService/CreateUser',
      request,
      metadata || {},
      methodDescriptor_UserService_CreateUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.SaveUserRequest,
 *   !proto.api.SaveUserResponse>}
 */
const methodDescriptor_UserService_UpdateUser = new grpc.web.MethodDescriptor(
  '/api.UserService/UpdateUser',
  grpc.web.MethodType.UNARY,
  proto.api.SaveUserRequest,
  proto.api.SaveUserResponse,
  /**
   * @param {!proto.api.SaveUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.SaveUserResponse.deserializeBinary
);


/**
 * @param {!proto.api.SaveUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.SaveUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.SaveUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.UserServiceClient.prototype.updateUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.UserService/UpdateUser',
      request,
      metadata || {},
      methodDescriptor_UserService_UpdateUser,
      callback);
};


/**
 * @param {!proto.api.SaveUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.SaveUserResponse>}
 *     Promise that resolves to the response
 */
proto.api.UserServicePromiseClient.prototype.updateUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.UserService/UpdateUser',
      request,
      metadata || {},
      methodDescriptor_UserService_UpdateUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.DeleteUserRequest,
 *   !proto.api.DeleteUserResponse>}
 */
const methodDescriptor_UserService_DeleteUser = new grpc.web.MethodDescriptor(
  '/api.UserService/DeleteUser',
  grpc.web.MethodType.UNARY,
  proto.api.DeleteUserRequest,
  proto.api.DeleteUserResponse,
  /**
   * @param {!proto.api.DeleteUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.DeleteUserResponse.deserializeBinary
);


/**
 * @param {!proto.api.DeleteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.DeleteUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.DeleteUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.UserServiceClient.prototype.deleteUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.UserService/DeleteUser',
      request,
      metadata || {},
      methodDescriptor_UserService_DeleteUser,
      callback);
};


/**
 * @param {!proto.api.DeleteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.DeleteUserResponse>}
 *     Promise that resolves to the response
 */
proto.api.UserServicePromiseClient.prototype.deleteUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.UserService/DeleteUser',
      request,
      metadata || {},
      methodDescriptor_UserService_DeleteUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.GetUserRequest,
 *   !proto.api.GetUserResponse>}
 */
const methodDescriptor_UserService_GetUser = new grpc.web.MethodDescriptor(
  '/api.UserService/GetUser',
  grpc.web.MethodType.UNARY,
  proto.api.GetUserRequest,
  proto.api.GetUserResponse,
  /**
   * @param {!proto.api.GetUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.GetUserResponse.deserializeBinary
);


/**
 * @param {!proto.api.GetUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.GetUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.GetUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.UserServiceClient.prototype.getUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.UserService/GetUser',
      request,
      metadata || {},
      methodDescriptor_UserService_GetUser,
      callback);
};


/**
 * @param {!proto.api.GetUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.GetUserResponse>}
 *     Promise that resolves to the response
 */
proto.api.UserServicePromiseClient.prototype.getUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.UserService/GetUser',
      request,
      metadata || {},
      methodDescriptor_UserService_GetUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.EnableUserRequest,
 *   !proto.api.EnableUserResponse>}
 */
const methodDescriptor_UserService_EnableUser = new grpc.web.MethodDescriptor(
  '/api.UserService/EnableUser',
  grpc.web.MethodType.UNARY,
  proto.api.EnableUserRequest,
  proto.api.EnableUserResponse,
  /**
   * @param {!proto.api.EnableUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.EnableUserResponse.deserializeBinary
);


/**
 * @param {!proto.api.EnableUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.EnableUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.EnableUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.UserServiceClient.prototype.enableUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.UserService/EnableUser',
      request,
      metadata || {},
      methodDescriptor_UserService_EnableUser,
      callback);
};


/**
 * @param {!proto.api.EnableUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.EnableUserResponse>}
 *     Promise that resolves to the response
 */
proto.api.UserServicePromiseClient.prototype.enableUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.UserService/EnableUser',
      request,
      metadata || {},
      methodDescriptor_UserService_EnableUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.DisableUserRequest,
 *   !proto.api.DisableUserResponse>}
 */
const methodDescriptor_UserService_DisableUser = new grpc.web.MethodDescriptor(
  '/api.UserService/DisableUser',
  grpc.web.MethodType.UNARY,
  proto.api.DisableUserRequest,
  proto.api.DisableUserResponse,
  /**
   * @param {!proto.api.DisableUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.DisableUserResponse.deserializeBinary
);


/**
 * @param {!proto.api.DisableUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.DisableUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.DisableUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.UserServiceClient.prototype.disableUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.UserService/DisableUser',
      request,
      metadata || {},
      methodDescriptor_UserService_DisableUser,
      callback);
};


/**
 * @param {!proto.api.DisableUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.DisableUserResponse>}
 *     Promise that resolves to the response
 */
proto.api.UserServicePromiseClient.prototype.disableUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.UserService/DisableUser',
      request,
      metadata || {},
      methodDescriptor_UserService_DisableUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ChangePasswordRequest,
 *   !proto.api.ChangePasswordResponse>}
 */
const methodDescriptor_UserService_ChangePassword = new grpc.web.MethodDescriptor(
  '/api.UserService/ChangePassword',
  grpc.web.MethodType.UNARY,
  proto.api.ChangePasswordRequest,
  proto.api.ChangePasswordResponse,
  /**
   * @param {!proto.api.ChangePasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ChangePasswordResponse.deserializeBinary
);


/**
 * @param {!proto.api.ChangePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ChangePasswordResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ChangePasswordResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.UserServiceClient.prototype.changePassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.UserService/ChangePassword',
      request,
      metadata || {},
      methodDescriptor_UserService_ChangePassword,
      callback);
};


/**
 * @param {!proto.api.ChangePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ChangePasswordResponse>}
 *     Promise that resolves to the response
 */
proto.api.UserServicePromiseClient.prototype.changePassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.UserService/ChangePassword',
      request,
      metadata || {},
      methodDescriptor_UserService_ChangePassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListUserDevicesRequest,
 *   !proto.api.ListUserDevicesResponse>}
 */
const methodDescriptor_UserService_ListDevices = new grpc.web.MethodDescriptor(
  '/api.UserService/ListDevices',
  grpc.web.MethodType.UNARY,
  proto.api.ListUserDevicesRequest,
  proto.api.ListUserDevicesResponse,
  /**
   * @param {!proto.api.ListUserDevicesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListUserDevicesResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListUserDevicesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListUserDevicesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListUserDevicesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.UserServiceClient.prototype.listDevices =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.UserService/ListDevices',
      request,
      metadata || {},
      methodDescriptor_UserService_ListDevices,
      callback);
};


/**
 * @param {!proto.api.ListUserDevicesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListUserDevicesResponse>}
 *     Promise that resolves to the response
 */
proto.api.UserServicePromiseClient.prototype.listDevices =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.UserService/ListDevices',
      request,
      metadata || {},
      methodDescriptor_UserService_ListDevices);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.RegisterDeviceRequest,
 *   !proto.api.RegisterDeviceResponse>}
 */
const methodDescriptor_UserService_RegisterDevice = new grpc.web.MethodDescriptor(
  '/api.UserService/RegisterDevice',
  grpc.web.MethodType.UNARY,
  proto.api.RegisterDeviceRequest,
  proto.api.RegisterDeviceResponse,
  /**
   * @param {!proto.api.RegisterDeviceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.RegisterDeviceResponse.deserializeBinary
);


/**
 * @param {!proto.api.RegisterDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.RegisterDeviceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.RegisterDeviceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.UserServiceClient.prototype.registerDevice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.UserService/RegisterDevice',
      request,
      metadata || {},
      methodDescriptor_UserService_RegisterDevice,
      callback);
};


/**
 * @param {!proto.api.RegisterDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.RegisterDeviceResponse>}
 *     Promise that resolves to the response
 */
proto.api.UserServicePromiseClient.prototype.registerDevice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.UserService/RegisterDevice',
      request,
      metadata || {},
      methodDescriptor_UserService_RegisterDevice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.UnregisterDeviceRequest,
 *   !proto.api.UnregisterDeviceResponse>}
 */
const methodDescriptor_UserService_UnregisterDevice = new grpc.web.MethodDescriptor(
  '/api.UserService/UnregisterDevice',
  grpc.web.MethodType.UNARY,
  proto.api.UnregisterDeviceRequest,
  proto.api.UnregisterDeviceResponse,
  /**
   * @param {!proto.api.UnregisterDeviceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.UnregisterDeviceResponse.deserializeBinary
);


/**
 * @param {!proto.api.UnregisterDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.UnregisterDeviceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.UnregisterDeviceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.UserServiceClient.prototype.unregisterDevice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.UserService/UnregisterDevice',
      request,
      metadata || {},
      methodDescriptor_UserService_UnregisterDevice,
      callback);
};


/**
 * @param {!proto.api.UnregisterDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.UnregisterDeviceResponse>}
 *     Promise that resolves to the response
 */
proto.api.UserServicePromiseClient.prototype.unregisterDevice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.UserService/UnregisterDevice',
      request,
      metadata || {},
      methodDescriptor_UserService_UnregisterDevice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.UpdateUserDeviceRequest,
 *   !proto.api.UpdateUserDeviceResponse>}
 */
const methodDescriptor_UserService_UpdateUserDevice = new grpc.web.MethodDescriptor(
  '/api.UserService/UpdateUserDevice',
  grpc.web.MethodType.UNARY,
  proto.api.UpdateUserDeviceRequest,
  proto.api.UpdateUserDeviceResponse,
  /**
   * @param {!proto.api.UpdateUserDeviceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.UpdateUserDeviceResponse.deserializeBinary
);


/**
 * @param {!proto.api.UpdateUserDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.UpdateUserDeviceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.UpdateUserDeviceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.UserServiceClient.prototype.updateUserDevice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.UserService/UpdateUserDevice',
      request,
      metadata || {},
      methodDescriptor_UserService_UpdateUserDevice,
      callback);
};


/**
 * @param {!proto.api.UpdateUserDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.UpdateUserDeviceResponse>}
 *     Promise that resolves to the response
 */
proto.api.UserServicePromiseClient.prototype.updateUserDevice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.UserService/UpdateUserDevice',
      request,
      metadata || {},
      methodDescriptor_UserService_UpdateUserDevice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.GetUserDeviceRequest,
 *   !proto.api.GetUserDeviceResponse>}
 */
const methodDescriptor_UserService_GetUserDevice = new grpc.web.MethodDescriptor(
  '/api.UserService/GetUserDevice',
  grpc.web.MethodType.UNARY,
  proto.api.GetUserDeviceRequest,
  proto.api.GetUserDeviceResponse,
  /**
   * @param {!proto.api.GetUserDeviceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.GetUserDeviceResponse.deserializeBinary
);


/**
 * @param {!proto.api.GetUserDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.GetUserDeviceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.GetUserDeviceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.UserServiceClient.prototype.getUserDevice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.UserService/GetUserDevice',
      request,
      metadata || {},
      methodDescriptor_UserService_GetUserDevice,
      callback);
};


/**
 * @param {!proto.api.GetUserDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.GetUserDeviceResponse>}
 *     Promise that resolves to the response
 */
proto.api.UserServicePromiseClient.prototype.getUserDevice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.UserService/GetUserDevice',
      request,
      metadata || {},
      methodDescriptor_UserService_GetUserDevice);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.AlarmServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.AlarmServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListAlarmsRequest,
 *   !proto.api.ListAlarmsResponse>}
 */
const methodDescriptor_AlarmService_ListAlarms = new grpc.web.MethodDescriptor(
  '/api.AlarmService/ListAlarms',
  grpc.web.MethodType.UNARY,
  proto.api.ListAlarmsRequest,
  proto.api.ListAlarmsResponse,
  /**
   * @param {!proto.api.ListAlarmsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListAlarmsResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListAlarmsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListAlarmsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListAlarmsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.AlarmServiceClient.prototype.listAlarms =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.AlarmService/ListAlarms',
      request,
      metadata || {},
      methodDescriptor_AlarmService_ListAlarms,
      callback);
};


/**
 * @param {!proto.api.ListAlarmsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListAlarmsResponse>}
 *     Promise that resolves to the response
 */
proto.api.AlarmServicePromiseClient.prototype.listAlarms =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.AlarmService/ListAlarms',
      request,
      metadata || {},
      methodDescriptor_AlarmService_ListAlarms);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.GetAlarmRequest,
 *   !proto.api.GetAlarmResponse>}
 */
const methodDescriptor_AlarmService_GetAlarm = new grpc.web.MethodDescriptor(
  '/api.AlarmService/GetAlarm',
  grpc.web.MethodType.UNARY,
  proto.api.GetAlarmRequest,
  proto.api.GetAlarmResponse,
  /**
   * @param {!proto.api.GetAlarmRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.GetAlarmResponse.deserializeBinary
);


/**
 * @param {!proto.api.GetAlarmRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.GetAlarmResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.GetAlarmResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.AlarmServiceClient.prototype.getAlarm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.AlarmService/GetAlarm',
      request,
      metadata || {},
      methodDescriptor_AlarmService_GetAlarm,
      callback);
};


/**
 * @param {!proto.api.GetAlarmRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.GetAlarmResponse>}
 *     Promise that resolves to the response
 */
proto.api.AlarmServicePromiseClient.prototype.getAlarm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.AlarmService/GetAlarm',
      request,
      metadata || {},
      methodDescriptor_AlarmService_GetAlarm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.UpdateAlarmRequest,
 *   !proto.api.UpdateAlarmResponse>}
 */
const methodDescriptor_AlarmService_UpdateAlarm = new grpc.web.MethodDescriptor(
  '/api.AlarmService/UpdateAlarm',
  grpc.web.MethodType.UNARY,
  proto.api.UpdateAlarmRequest,
  proto.api.UpdateAlarmResponse,
  /**
   * @param {!proto.api.UpdateAlarmRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.UpdateAlarmResponse.deserializeBinary
);


/**
 * @param {!proto.api.UpdateAlarmRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.UpdateAlarmResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.UpdateAlarmResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.AlarmServiceClient.prototype.updateAlarm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.AlarmService/UpdateAlarm',
      request,
      metadata || {},
      methodDescriptor_AlarmService_UpdateAlarm,
      callback);
};


/**
 * @param {!proto.api.UpdateAlarmRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.UpdateAlarmResponse>}
 *     Promise that resolves to the response
 */
proto.api.AlarmServicePromiseClient.prototype.updateAlarm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.AlarmService/UpdateAlarm',
      request,
      metadata || {},
      methodDescriptor_AlarmService_UpdateAlarm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.CloseAlarmsRequest,
 *   !proto.api.CloseAlarmsResponse>}
 */
const methodDescriptor_AlarmService_CloseAlarms = new grpc.web.MethodDescriptor(
  '/api.AlarmService/CloseAlarms',
  grpc.web.MethodType.UNARY,
  proto.api.CloseAlarmsRequest,
  proto.api.CloseAlarmsResponse,
  /**
   * @param {!proto.api.CloseAlarmsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.CloseAlarmsResponse.deserializeBinary
);


/**
 * @param {!proto.api.CloseAlarmsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.CloseAlarmsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.CloseAlarmsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.AlarmServiceClient.prototype.closeAlarms =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.AlarmService/CloseAlarms',
      request,
      metadata || {},
      methodDescriptor_AlarmService_CloseAlarms,
      callback);
};


/**
 * @param {!proto.api.CloseAlarmsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.CloseAlarmsResponse>}
 *     Promise that resolves to the response
 */
proto.api.AlarmServicePromiseClient.prototype.closeAlarms =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.AlarmService/CloseAlarms',
      request,
      metadata || {},
      methodDescriptor_AlarmService_CloseAlarms);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.TakeOwnershipRequest,
 *   !proto.api.TakeOwnershipResponse>}
 */
const methodDescriptor_AlarmService_TakeOwnership = new grpc.web.MethodDescriptor(
  '/api.AlarmService/TakeOwnership',
  grpc.web.MethodType.UNARY,
  proto.api.TakeOwnershipRequest,
  proto.api.TakeOwnershipResponse,
  /**
   * @param {!proto.api.TakeOwnershipRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.TakeOwnershipResponse.deserializeBinary
);


/**
 * @param {!proto.api.TakeOwnershipRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.TakeOwnershipResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.TakeOwnershipResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.AlarmServiceClient.prototype.takeOwnership =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.AlarmService/TakeOwnership',
      request,
      metadata || {},
      methodDescriptor_AlarmService_TakeOwnership,
      callback);
};


/**
 * @param {!proto.api.TakeOwnershipRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.TakeOwnershipResponse>}
 *     Promise that resolves to the response
 */
proto.api.AlarmServicePromiseClient.prototype.takeOwnership =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.AlarmService/TakeOwnership',
      request,
      metadata || {},
      methodDescriptor_AlarmService_TakeOwnership);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ForwardRequest,
 *   !proto.api.ForwardResponse>}
 */
const methodDescriptor_AlarmService_Forward = new grpc.web.MethodDescriptor(
  '/api.AlarmService/Forward',
  grpc.web.MethodType.UNARY,
  proto.api.ForwardRequest,
  proto.api.ForwardResponse,
  /**
   * @param {!proto.api.ForwardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ForwardResponse.deserializeBinary
);


/**
 * @param {!proto.api.ForwardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ForwardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ForwardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.AlarmServiceClient.prototype.forward =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.AlarmService/Forward',
      request,
      metadata || {},
      methodDescriptor_AlarmService_Forward,
      callback);
};


/**
 * @param {!proto.api.ForwardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ForwardResponse>}
 *     Promise that resolves to the response
 */
proto.api.AlarmServicePromiseClient.prototype.forward =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.AlarmService/Forward',
      request,
      metadata || {},
      methodDescriptor_AlarmService_Forward);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.MarkAsReadRequest,
 *   !proto.api.MarkAsReadResponse>}
 */
const methodDescriptor_AlarmService_MarkAsRead = new grpc.web.MethodDescriptor(
  '/api.AlarmService/MarkAsRead',
  grpc.web.MethodType.UNARY,
  proto.api.MarkAsReadRequest,
  proto.api.MarkAsReadResponse,
  /**
   * @param {!proto.api.MarkAsReadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.MarkAsReadResponse.deserializeBinary
);


/**
 * @param {!proto.api.MarkAsReadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.MarkAsReadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.MarkAsReadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.AlarmServiceClient.prototype.markAsRead =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.AlarmService/MarkAsRead',
      request,
      metadata || {},
      methodDescriptor_AlarmService_MarkAsRead,
      callback);
};


/**
 * @param {!proto.api.MarkAsReadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.MarkAsReadResponse>}
 *     Promise that resolves to the response
 */
proto.api.AlarmServicePromiseClient.prototype.markAsRead =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.AlarmService/MarkAsRead',
      request,
      metadata || {},
      methodDescriptor_AlarmService_MarkAsRead);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.GetAlarmsCountRequest,
 *   !proto.api.GetAlarmsCountResponse>}
 */
const methodDescriptor_AlarmService_GetAlarmsCount = new grpc.web.MethodDescriptor(
  '/api.AlarmService/GetAlarmsCount',
  grpc.web.MethodType.UNARY,
  proto.api.GetAlarmsCountRequest,
  proto.api.GetAlarmsCountResponse,
  /**
   * @param {!proto.api.GetAlarmsCountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.GetAlarmsCountResponse.deserializeBinary
);


/**
 * @param {!proto.api.GetAlarmsCountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.GetAlarmsCountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.GetAlarmsCountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.AlarmServiceClient.prototype.getAlarmsCount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.AlarmService/GetAlarmsCount',
      request,
      metadata || {},
      methodDescriptor_AlarmService_GetAlarmsCount,
      callback);
};


/**
 * @param {!proto.api.GetAlarmsCountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.GetAlarmsCountResponse>}
 *     Promise that resolves to the response
 */
proto.api.AlarmServicePromiseClient.prototype.getAlarmsCount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.AlarmService/GetAlarmsCount',
      request,
      metadata || {},
      methodDescriptor_AlarmService_GetAlarmsCount);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.EventServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.EventServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListEventsRequest,
 *   !proto.api.ListEventsResponse>}
 */
const methodDescriptor_EventService_ListEvents = new grpc.web.MethodDescriptor(
  '/api.EventService/ListEvents',
  grpc.web.MethodType.UNARY,
  proto.api.ListEventsRequest,
  proto.api.ListEventsResponse,
  /**
   * @param {!proto.api.ListEventsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListEventsResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListEventsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListEventsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListEventsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.EventServiceClient.prototype.listEvents =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.EventService/ListEvents',
      request,
      metadata || {},
      methodDescriptor_EventService_ListEvents,
      callback);
};


/**
 * @param {!proto.api.ListEventsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListEventsResponse>}
 *     Promise that resolves to the response
 */
proto.api.EventServicePromiseClient.prototype.listEvents =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.EventService/ListEvents',
      request,
      metadata || {},
      methodDescriptor_EventService_ListEvents);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.CustomerServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.CustomerServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListCustomersRequest,
 *   !proto.api.ListCustomersResponse>}
 */
const methodDescriptor_CustomerService_ListCustomers = new grpc.web.MethodDescriptor(
  '/api.CustomerService/ListCustomers',
  grpc.web.MethodType.UNARY,
  proto.api.ListCustomersRequest,
  proto.api.ListCustomersResponse,
  /**
   * @param {!proto.api.ListCustomersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListCustomersResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListCustomersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListCustomersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListCustomersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.CustomerServiceClient.prototype.listCustomers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.CustomerService/ListCustomers',
      request,
      metadata || {},
      methodDescriptor_CustomerService_ListCustomers,
      callback);
};


/**
 * @param {!proto.api.ListCustomersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListCustomersResponse>}
 *     Promise that resolves to the response
 */
proto.api.CustomerServicePromiseClient.prototype.listCustomers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.CustomerService/ListCustomers',
      request,
      metadata || {},
      methodDescriptor_CustomerService_ListCustomers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.SaveCustomerRequest,
 *   !proto.api.SaveCustomerResponse>}
 */
const methodDescriptor_CustomerService_CreateCustomer = new grpc.web.MethodDescriptor(
  '/api.CustomerService/CreateCustomer',
  grpc.web.MethodType.UNARY,
  proto.api.SaveCustomerRequest,
  proto.api.SaveCustomerResponse,
  /**
   * @param {!proto.api.SaveCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.SaveCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.api.SaveCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.SaveCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.SaveCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.CustomerServiceClient.prototype.createCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.CustomerService/CreateCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerService_CreateCustomer,
      callback);
};


/**
 * @param {!proto.api.SaveCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.SaveCustomerResponse>}
 *     Promise that resolves to the response
 */
proto.api.CustomerServicePromiseClient.prototype.createCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.CustomerService/CreateCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerService_CreateCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.SaveCustomerRequest,
 *   !proto.api.SaveCustomerResponse>}
 */
const methodDescriptor_CustomerService_UpdateCustomer = new grpc.web.MethodDescriptor(
  '/api.CustomerService/UpdateCustomer',
  grpc.web.MethodType.UNARY,
  proto.api.SaveCustomerRequest,
  proto.api.SaveCustomerResponse,
  /**
   * @param {!proto.api.SaveCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.SaveCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.api.SaveCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.SaveCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.SaveCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.CustomerServiceClient.prototype.updateCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.CustomerService/UpdateCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerService_UpdateCustomer,
      callback);
};


/**
 * @param {!proto.api.SaveCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.SaveCustomerResponse>}
 *     Promise that resolves to the response
 */
proto.api.CustomerServicePromiseClient.prototype.updateCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.CustomerService/UpdateCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerService_UpdateCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.DeleteCustomerRequest,
 *   !proto.api.DeleteCustomerResponse>}
 */
const methodDescriptor_CustomerService_DeleteCustomer = new grpc.web.MethodDescriptor(
  '/api.CustomerService/DeleteCustomer',
  grpc.web.MethodType.UNARY,
  proto.api.DeleteCustomerRequest,
  proto.api.DeleteCustomerResponse,
  /**
   * @param {!proto.api.DeleteCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.DeleteCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.api.DeleteCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.DeleteCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.DeleteCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.CustomerServiceClient.prototype.deleteCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.CustomerService/DeleteCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerService_DeleteCustomer,
      callback);
};


/**
 * @param {!proto.api.DeleteCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.DeleteCustomerResponse>}
 *     Promise that resolves to the response
 */
proto.api.CustomerServicePromiseClient.prototype.deleteCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.CustomerService/DeleteCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerService_DeleteCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.GetCustomerRequest,
 *   !proto.api.GetCustomerResponse>}
 */
const methodDescriptor_CustomerService_GetCustomer = new grpc.web.MethodDescriptor(
  '/api.CustomerService/GetCustomer',
  grpc.web.MethodType.UNARY,
  proto.api.GetCustomerRequest,
  proto.api.GetCustomerResponse,
  /**
   * @param {!proto.api.GetCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.GetCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.api.GetCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.GetCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.GetCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.CustomerServiceClient.prototype.getCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.CustomerService/GetCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetCustomer,
      callback);
};


/**
 * @param {!proto.api.GetCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.GetCustomerResponse>}
 *     Promise that resolves to the response
 */
proto.api.CustomerServicePromiseClient.prototype.getCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.CustomerService/GetCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.StartRecordingRequest,
 *   !proto.api.StartRecordingResponse>}
 */
const methodDescriptor_CustomerService_StartRecording = new grpc.web.MethodDescriptor(
  '/api.CustomerService/StartRecording',
  grpc.web.MethodType.UNARY,
  proto.api.StartRecordingRequest,
  proto.api.StartRecordingResponse,
  /**
   * @param {!proto.api.StartRecordingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.StartRecordingResponse.deserializeBinary
);


/**
 * @param {!proto.api.StartRecordingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.StartRecordingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.StartRecordingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.CustomerServiceClient.prototype.startRecording =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.CustomerService/StartRecording',
      request,
      metadata || {},
      methodDescriptor_CustomerService_StartRecording,
      callback);
};


/**
 * @param {!proto.api.StartRecordingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.StartRecordingResponse>}
 *     Promise that resolves to the response
 */
proto.api.CustomerServicePromiseClient.prototype.startRecording =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.CustomerService/StartRecording',
      request,
      metadata || {},
      methodDescriptor_CustomerService_StartRecording);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.StopRecordingRequest,
 *   !proto.api.StopRecordingResponse>}
 */
const methodDescriptor_CustomerService_StopRecording = new grpc.web.MethodDescriptor(
  '/api.CustomerService/StopRecording',
  grpc.web.MethodType.UNARY,
  proto.api.StopRecordingRequest,
  proto.api.StopRecordingResponse,
  /**
   * @param {!proto.api.StopRecordingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.StopRecordingResponse.deserializeBinary
);


/**
 * @param {!proto.api.StopRecordingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.StopRecordingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.StopRecordingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.CustomerServiceClient.prototype.stopRecording =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.CustomerService/StopRecording',
      request,
      metadata || {},
      methodDescriptor_CustomerService_StopRecording,
      callback);
};


/**
 * @param {!proto.api.StopRecordingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.StopRecordingResponse>}
 *     Promise that resolves to the response
 */
proto.api.CustomerServicePromiseClient.prototype.stopRecording =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.CustomerService/StopRecording',
      request,
      metadata || {},
      methodDescriptor_CustomerService_StopRecording);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.GetUserRunningRecordingRequest,
 *   !proto.api.GetUserRunningRecordingResponse>}
 */
const methodDescriptor_CustomerService_GetUserRunningRecording = new grpc.web.MethodDescriptor(
  '/api.CustomerService/GetUserRunningRecording',
  grpc.web.MethodType.UNARY,
  proto.api.GetUserRunningRecordingRequest,
  proto.api.GetUserRunningRecordingResponse,
  /**
   * @param {!proto.api.GetUserRunningRecordingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.GetUserRunningRecordingResponse.deserializeBinary
);


/**
 * @param {!proto.api.GetUserRunningRecordingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.GetUserRunningRecordingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.GetUserRunningRecordingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.CustomerServiceClient.prototype.getUserRunningRecording =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.CustomerService/GetUserRunningRecording',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetUserRunningRecording,
      callback);
};


/**
 * @param {!proto.api.GetUserRunningRecordingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.GetUserRunningRecordingResponse>}
 *     Promise that resolves to the response
 */
proto.api.CustomerServicePromiseClient.prototype.getUserRunningRecording =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.CustomerService/GetUserRunningRecording',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetUserRunningRecording);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListRecordingsRequest,
 *   !proto.api.ListRecordingsResponse>}
 */
const methodDescriptor_CustomerService_ListRecordings = new grpc.web.MethodDescriptor(
  '/api.CustomerService/ListRecordings',
  grpc.web.MethodType.UNARY,
  proto.api.ListRecordingsRequest,
  proto.api.ListRecordingsResponse,
  /**
   * @param {!proto.api.ListRecordingsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListRecordingsResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListRecordingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListRecordingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListRecordingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.CustomerServiceClient.prototype.listRecordings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.CustomerService/ListRecordings',
      request,
      metadata || {},
      methodDescriptor_CustomerService_ListRecordings,
      callback);
};


/**
 * @param {!proto.api.ListRecordingsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListRecordingsResponse>}
 *     Promise that resolves to the response
 */
proto.api.CustomerServicePromiseClient.prototype.listRecordings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.CustomerService/ListRecordings',
      request,
      metadata || {},
      methodDescriptor_CustomerService_ListRecordings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.GetRecordingsStatsRequest,
 *   !proto.api.GetRecordingsStatsResponse>}
 */
const methodDescriptor_CustomerService_GetRecordingsStats = new grpc.web.MethodDescriptor(
  '/api.CustomerService/GetRecordingsStats',
  grpc.web.MethodType.UNARY,
  proto.api.GetRecordingsStatsRequest,
  proto.api.GetRecordingsStatsResponse,
  /**
   * @param {!proto.api.GetRecordingsStatsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.GetRecordingsStatsResponse.deserializeBinary
);


/**
 * @param {!proto.api.GetRecordingsStatsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.GetRecordingsStatsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.GetRecordingsStatsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.CustomerServiceClient.prototype.getRecordingsStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.CustomerService/GetRecordingsStats',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetRecordingsStats,
      callback);
};


/**
 * @param {!proto.api.GetRecordingsStatsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.GetRecordingsStatsResponse>}
 *     Promise that resolves to the response
 */
proto.api.CustomerServicePromiseClient.prototype.getRecordingsStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.CustomerService/GetRecordingsStats',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetRecordingsStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.GetSystemRecordingsStatsRequest,
 *   !proto.api.GetSystemRecordingsStatsResponse>}
 */
const methodDescriptor_CustomerService_GetSystemRecordingsStats = new grpc.web.MethodDescriptor(
  '/api.CustomerService/GetSystemRecordingsStats',
  grpc.web.MethodType.UNARY,
  proto.api.GetSystemRecordingsStatsRequest,
  proto.api.GetSystemRecordingsStatsResponse,
  /**
   * @param {!proto.api.GetSystemRecordingsStatsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.GetSystemRecordingsStatsResponse.deserializeBinary
);


/**
 * @param {!proto.api.GetSystemRecordingsStatsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.GetSystemRecordingsStatsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.GetSystemRecordingsStatsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.CustomerServiceClient.prototype.getSystemRecordingsStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.CustomerService/GetSystemRecordingsStats',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetSystemRecordingsStats,
      callback);
};


/**
 * @param {!proto.api.GetSystemRecordingsStatsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.GetSystemRecordingsStatsResponse>}
 *     Promise that resolves to the response
 */
proto.api.CustomerServicePromiseClient.prototype.getSystemRecordingsStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.CustomerService/GetSystemRecordingsStats',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetSystemRecordingsStats);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.UpdatesServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.UpdatesServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.UpdatesSubscriptionRequest,
 *   !proto.api.UpdatesSubscriptionRecord>}
 */
const methodDescriptor_UpdatesService_Subscribe = new grpc.web.MethodDescriptor(
  '/api.UpdatesService/Subscribe',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.api.UpdatesSubscriptionRequest,
  proto.api.UpdatesSubscriptionRecord,
  /**
   * @param {!proto.api.UpdatesSubscriptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.UpdatesSubscriptionRecord.deserializeBinary
);


/**
 * @param {!proto.api.UpdatesSubscriptionRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.api.UpdatesSubscriptionRecord>}
 *     The XHR Node Readable Stream
 */
proto.api.UpdatesServiceClient.prototype.subscribe =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/api.UpdatesService/Subscribe',
      request,
      metadata || {},
      methodDescriptor_UpdatesService_Subscribe);
};


/**
 * @param {!proto.api.UpdatesSubscriptionRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.api.UpdatesSubscriptionRecord>}
 *     The XHR Node Readable Stream
 */
proto.api.UpdatesServicePromiseClient.prototype.subscribe =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/api.UpdatesService/Subscribe',
      request,
      metadata || {},
      methodDescriptor_UpdatesService_Subscribe);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.NotificationServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.NotificationServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListNotificationRequest,
 *   !proto.api.ListNotificationResponse>}
 */
const methodDescriptor_NotificationService_ListNotifications = new grpc.web.MethodDescriptor(
  '/api.NotificationService/ListNotifications',
  grpc.web.MethodType.UNARY,
  proto.api.ListNotificationRequest,
  proto.api.ListNotificationResponse,
  /**
   * @param {!proto.api.ListNotificationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListNotificationResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListNotificationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListNotificationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListNotificationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.NotificationServiceClient.prototype.listNotifications =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.NotificationService/ListNotifications',
      request,
      metadata || {},
      methodDescriptor_NotificationService_ListNotifications,
      callback);
};


/**
 * @param {!proto.api.ListNotificationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListNotificationResponse>}
 *     Promise that resolves to the response
 */
proto.api.NotificationServicePromiseClient.prototype.listNotifications =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.NotificationService/ListNotifications',
      request,
      metadata || {},
      methodDescriptor_NotificationService_ListNotifications);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.SaveNotificationRequest,
 *   !proto.api.SaveNotificationResponse>}
 */
const methodDescriptor_NotificationService_CreateNotification = new grpc.web.MethodDescriptor(
  '/api.NotificationService/CreateNotification',
  grpc.web.MethodType.UNARY,
  proto.api.SaveNotificationRequest,
  proto.api.SaveNotificationResponse,
  /**
   * @param {!proto.api.SaveNotificationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.SaveNotificationResponse.deserializeBinary
);


/**
 * @param {!proto.api.SaveNotificationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.SaveNotificationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.SaveNotificationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.NotificationServiceClient.prototype.createNotification =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.NotificationService/CreateNotification',
      request,
      metadata || {},
      methodDescriptor_NotificationService_CreateNotification,
      callback);
};


/**
 * @param {!proto.api.SaveNotificationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.SaveNotificationResponse>}
 *     Promise that resolves to the response
 */
proto.api.NotificationServicePromiseClient.prototype.createNotification =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.NotificationService/CreateNotification',
      request,
      metadata || {},
      methodDescriptor_NotificationService_CreateNotification);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.SaveNotificationRequest,
 *   !proto.api.SaveNotificationResponse>}
 */
const methodDescriptor_NotificationService_UpdateNotification = new grpc.web.MethodDescriptor(
  '/api.NotificationService/UpdateNotification',
  grpc.web.MethodType.UNARY,
  proto.api.SaveNotificationRequest,
  proto.api.SaveNotificationResponse,
  /**
   * @param {!proto.api.SaveNotificationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.SaveNotificationResponse.deserializeBinary
);


/**
 * @param {!proto.api.SaveNotificationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.SaveNotificationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.SaveNotificationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.NotificationServiceClient.prototype.updateNotification =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.NotificationService/UpdateNotification',
      request,
      metadata || {},
      methodDescriptor_NotificationService_UpdateNotification,
      callback);
};


/**
 * @param {!proto.api.SaveNotificationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.SaveNotificationResponse>}
 *     Promise that resolves to the response
 */
proto.api.NotificationServicePromiseClient.prototype.updateNotification =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.NotificationService/UpdateNotification',
      request,
      metadata || {},
      methodDescriptor_NotificationService_UpdateNotification);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.ShiftServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.ShiftServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.SaveShiftRequest,
 *   !proto.api.SaveShiftResponse>}
 */
const methodDescriptor_ShiftService_SaveShift = new grpc.web.MethodDescriptor(
  '/api.ShiftService/SaveShift',
  grpc.web.MethodType.UNARY,
  proto.api.SaveShiftRequest,
  proto.api.SaveShiftResponse,
  /**
   * @param {!proto.api.SaveShiftRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.SaveShiftResponse.deserializeBinary
);


/**
 * @param {!proto.api.SaveShiftRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.SaveShiftResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.SaveShiftResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.ShiftServiceClient.prototype.saveShift =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.ShiftService/SaveShift',
      request,
      metadata || {},
      methodDescriptor_ShiftService_SaveShift,
      callback);
};


/**
 * @param {!proto.api.SaveShiftRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.SaveShiftResponse>}
 *     Promise that resolves to the response
 */
proto.api.ShiftServicePromiseClient.prototype.saveShift =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.ShiftService/SaveShift',
      request,
      metadata || {},
      methodDescriptor_ShiftService_SaveShift);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListShiftsRequest,
 *   !proto.api.ListShiftsResponse>}
 */
const methodDescriptor_ShiftService_ListShifts = new grpc.web.MethodDescriptor(
  '/api.ShiftService/ListShifts',
  grpc.web.MethodType.UNARY,
  proto.api.ListShiftsRequest,
  proto.api.ListShiftsResponse,
  /**
   * @param {!proto.api.ListShiftsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListShiftsResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListShiftsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListShiftsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListShiftsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.ShiftServiceClient.prototype.listShifts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.ShiftService/ListShifts',
      request,
      metadata || {},
      methodDescriptor_ShiftService_ListShifts,
      callback);
};


/**
 * @param {!proto.api.ListShiftsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListShiftsResponse>}
 *     Promise that resolves to the response
 */
proto.api.ShiftServicePromiseClient.prototype.listShifts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.ShiftService/ListShifts',
      request,
      metadata || {},
      methodDescriptor_ShiftService_ListShifts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.GetUserShiftRequest,
 *   !proto.api.GetUserShiftResponse>}
 */
const methodDescriptor_ShiftService_GetUserShift = new grpc.web.MethodDescriptor(
  '/api.ShiftService/GetUserShift',
  grpc.web.MethodType.UNARY,
  proto.api.GetUserShiftRequest,
  proto.api.GetUserShiftResponse,
  /**
   * @param {!proto.api.GetUserShiftRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.GetUserShiftResponse.deserializeBinary
);


/**
 * @param {!proto.api.GetUserShiftRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.GetUserShiftResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.GetUserShiftResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.ShiftServiceClient.prototype.getUserShift =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.ShiftService/GetUserShift',
      request,
      metadata || {},
      methodDescriptor_ShiftService_GetUserShift,
      callback);
};


/**
 * @param {!proto.api.GetUserShiftRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.GetUserShiftResponse>}
 *     Promise that resolves to the response
 */
proto.api.ShiftServicePromiseClient.prototype.getUserShift =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.ShiftService/GetUserShift',
      request,
      metadata || {},
      methodDescriptor_ShiftService_GetUserShift);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.DeviceServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.DeviceServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListDevicesRequest,
 *   !proto.api.ListDevicesResponse>}
 */
const methodDescriptor_DeviceService_ListDevices = new grpc.web.MethodDescriptor(
  '/api.DeviceService/ListDevices',
  grpc.web.MethodType.UNARY,
  proto.api.ListDevicesRequest,
  proto.api.ListDevicesResponse,
  /**
   * @param {!proto.api.ListDevicesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListDevicesResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListDevicesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListDevicesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListDevicesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.DeviceServiceClient.prototype.listDevices =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.DeviceService/ListDevices',
      request,
      metadata || {},
      methodDescriptor_DeviceService_ListDevices,
      callback);
};


/**
 * @param {!proto.api.ListDevicesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListDevicesResponse>}
 *     Promise that resolves to the response
 */
proto.api.DeviceServicePromiseClient.prototype.listDevices =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.DeviceService/ListDevices',
      request,
      metadata || {},
      methodDescriptor_DeviceService_ListDevices);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.SaveDeviceRequest,
 *   !proto.api.SaveDeviceResponse>}
 */
const methodDescriptor_DeviceService_CreateDevice = new grpc.web.MethodDescriptor(
  '/api.DeviceService/CreateDevice',
  grpc.web.MethodType.UNARY,
  proto.api.SaveDeviceRequest,
  proto.api.SaveDeviceResponse,
  /**
   * @param {!proto.api.SaveDeviceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.SaveDeviceResponse.deserializeBinary
);


/**
 * @param {!proto.api.SaveDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.SaveDeviceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.SaveDeviceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.DeviceServiceClient.prototype.createDevice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.DeviceService/CreateDevice',
      request,
      metadata || {},
      methodDescriptor_DeviceService_CreateDevice,
      callback);
};


/**
 * @param {!proto.api.SaveDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.SaveDeviceResponse>}
 *     Promise that resolves to the response
 */
proto.api.DeviceServicePromiseClient.prototype.createDevice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.DeviceService/CreateDevice',
      request,
      metadata || {},
      methodDescriptor_DeviceService_CreateDevice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.SaveDeviceRequest,
 *   !proto.api.SaveDeviceResponse>}
 */
const methodDescriptor_DeviceService_UpdateDevice = new grpc.web.MethodDescriptor(
  '/api.DeviceService/UpdateDevice',
  grpc.web.MethodType.UNARY,
  proto.api.SaveDeviceRequest,
  proto.api.SaveDeviceResponse,
  /**
   * @param {!proto.api.SaveDeviceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.SaveDeviceResponse.deserializeBinary
);


/**
 * @param {!proto.api.SaveDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.SaveDeviceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.SaveDeviceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.DeviceServiceClient.prototype.updateDevice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.DeviceService/UpdateDevice',
      request,
      metadata || {},
      methodDescriptor_DeviceService_UpdateDevice,
      callback);
};


/**
 * @param {!proto.api.SaveDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.SaveDeviceResponse>}
 *     Promise that resolves to the response
 */
proto.api.DeviceServicePromiseClient.prototype.updateDevice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.DeviceService/UpdateDevice',
      request,
      metadata || {},
      methodDescriptor_DeviceService_UpdateDevice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.DeleteDeviceRequest,
 *   !proto.api.DeleteDeviceResponse>}
 */
const methodDescriptor_DeviceService_DeleteDevice = new grpc.web.MethodDescriptor(
  '/api.DeviceService/DeleteDevice',
  grpc.web.MethodType.UNARY,
  proto.api.DeleteDeviceRequest,
  proto.api.DeleteDeviceResponse,
  /**
   * @param {!proto.api.DeleteDeviceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.DeleteDeviceResponse.deserializeBinary
);


/**
 * @param {!proto.api.DeleteDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.DeleteDeviceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.DeleteDeviceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.DeviceServiceClient.prototype.deleteDevice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.DeviceService/DeleteDevice',
      request,
      metadata || {},
      methodDescriptor_DeviceService_DeleteDevice,
      callback);
};


/**
 * @param {!proto.api.DeleteDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.DeleteDeviceResponse>}
 *     Promise that resolves to the response
 */
proto.api.DeviceServicePromiseClient.prototype.deleteDevice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.DeviceService/DeleteDevice',
      request,
      metadata || {},
      methodDescriptor_DeviceService_DeleteDevice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.GetDeviceRequest,
 *   !proto.api.GetDeviceResponse>}
 */
const methodDescriptor_DeviceService_GetDevice = new grpc.web.MethodDescriptor(
  '/api.DeviceService/GetDevice',
  grpc.web.MethodType.UNARY,
  proto.api.GetDeviceRequest,
  proto.api.GetDeviceResponse,
  /**
   * @param {!proto.api.GetDeviceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.GetDeviceResponse.deserializeBinary
);


/**
 * @param {!proto.api.GetDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.GetDeviceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.GetDeviceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.DeviceServiceClient.prototype.getDevice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.DeviceService/GetDevice',
      request,
      metadata || {},
      methodDescriptor_DeviceService_GetDevice,
      callback);
};


/**
 * @param {!proto.api.GetDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.GetDeviceResponse>}
 *     Promise that resolves to the response
 */
proto.api.DeviceServicePromiseClient.prototype.getDevice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.DeviceService/GetDevice',
      request,
      metadata || {},
      methodDescriptor_DeviceService_GetDevice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListDeviceAlarmsRequest,
 *   !proto.api.ListDeviceAlarmsResponse>}
 */
const methodDescriptor_DeviceService_ListDeviceAlarms = new grpc.web.MethodDescriptor(
  '/api.DeviceService/ListDeviceAlarms',
  grpc.web.MethodType.UNARY,
  proto.api.ListDeviceAlarmsRequest,
  proto.api.ListDeviceAlarmsResponse,
  /**
   * @param {!proto.api.ListDeviceAlarmsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListDeviceAlarmsResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListDeviceAlarmsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListDeviceAlarmsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListDeviceAlarmsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.DeviceServiceClient.prototype.listDeviceAlarms =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.DeviceService/ListDeviceAlarms',
      request,
      metadata || {},
      methodDescriptor_DeviceService_ListDeviceAlarms,
      callback);
};


/**
 * @param {!proto.api.ListDeviceAlarmsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListDeviceAlarmsResponse>}
 *     Promise that resolves to the response
 */
proto.api.DeviceServicePromiseClient.prototype.listDeviceAlarms =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.DeviceService/ListDeviceAlarms',
      request,
      metadata || {},
      methodDescriptor_DeviceService_ListDeviceAlarms);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.FindDeviceAlarmsRequest,
 *   !proto.api.FindDeviceAlarmsResponse>}
 */
const methodDescriptor_DeviceService_FindDeviceAlarm = new grpc.web.MethodDescriptor(
  '/api.DeviceService/FindDeviceAlarm',
  grpc.web.MethodType.UNARY,
  proto.api.FindDeviceAlarmsRequest,
  proto.api.FindDeviceAlarmsResponse,
  /**
   * @param {!proto.api.FindDeviceAlarmsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.FindDeviceAlarmsResponse.deserializeBinary
);


/**
 * @param {!proto.api.FindDeviceAlarmsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.FindDeviceAlarmsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.FindDeviceAlarmsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.DeviceServiceClient.prototype.findDeviceAlarm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.DeviceService/FindDeviceAlarm',
      request,
      metadata || {},
      methodDescriptor_DeviceService_FindDeviceAlarm,
      callback);
};


/**
 * @param {!proto.api.FindDeviceAlarmsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.FindDeviceAlarmsResponse>}
 *     Promise that resolves to the response
 */
proto.api.DeviceServicePromiseClient.prototype.findDeviceAlarm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.DeviceService/FindDeviceAlarm',
      request,
      metadata || {},
      methodDescriptor_DeviceService_FindDeviceAlarm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.SaveDeviceAlarmRequest,
 *   !proto.api.SaveDeviceAlarmResponse>}
 */
const methodDescriptor_DeviceService_CreateDeviceAlarm = new grpc.web.MethodDescriptor(
  '/api.DeviceService/CreateDeviceAlarm',
  grpc.web.MethodType.UNARY,
  proto.api.SaveDeviceAlarmRequest,
  proto.api.SaveDeviceAlarmResponse,
  /**
   * @param {!proto.api.SaveDeviceAlarmRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.SaveDeviceAlarmResponse.deserializeBinary
);


/**
 * @param {!proto.api.SaveDeviceAlarmRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.SaveDeviceAlarmResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.SaveDeviceAlarmResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.DeviceServiceClient.prototype.createDeviceAlarm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.DeviceService/CreateDeviceAlarm',
      request,
      metadata || {},
      methodDescriptor_DeviceService_CreateDeviceAlarm,
      callback);
};


/**
 * @param {!proto.api.SaveDeviceAlarmRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.SaveDeviceAlarmResponse>}
 *     Promise that resolves to the response
 */
proto.api.DeviceServicePromiseClient.prototype.createDeviceAlarm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.DeviceService/CreateDeviceAlarm',
      request,
      metadata || {},
      methodDescriptor_DeviceService_CreateDeviceAlarm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.SaveDeviceAlarmRequest,
 *   !proto.api.SaveDeviceAlarmResponse>}
 */
const methodDescriptor_DeviceService_UpdateDeviceAlarm = new grpc.web.MethodDescriptor(
  '/api.DeviceService/UpdateDeviceAlarm',
  grpc.web.MethodType.UNARY,
  proto.api.SaveDeviceAlarmRequest,
  proto.api.SaveDeviceAlarmResponse,
  /**
   * @param {!proto.api.SaveDeviceAlarmRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.SaveDeviceAlarmResponse.deserializeBinary
);


/**
 * @param {!proto.api.SaveDeviceAlarmRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.SaveDeviceAlarmResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.SaveDeviceAlarmResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.DeviceServiceClient.prototype.updateDeviceAlarm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.DeviceService/UpdateDeviceAlarm',
      request,
      metadata || {},
      methodDescriptor_DeviceService_UpdateDeviceAlarm,
      callback);
};


/**
 * @param {!proto.api.SaveDeviceAlarmRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.SaveDeviceAlarmResponse>}
 *     Promise that resolves to the response
 */
proto.api.DeviceServicePromiseClient.prototype.updateDeviceAlarm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.DeviceService/UpdateDeviceAlarm',
      request,
      metadata || {},
      methodDescriptor_DeviceService_UpdateDeviceAlarm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.DeleteDeviceAlarmRequest,
 *   !proto.api.DeleteDeviceAlarmResponse>}
 */
const methodDescriptor_DeviceService_DeleteDeviceAlarm = new grpc.web.MethodDescriptor(
  '/api.DeviceService/DeleteDeviceAlarm',
  grpc.web.MethodType.UNARY,
  proto.api.DeleteDeviceAlarmRequest,
  proto.api.DeleteDeviceAlarmResponse,
  /**
   * @param {!proto.api.DeleteDeviceAlarmRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.DeleteDeviceAlarmResponse.deserializeBinary
);


/**
 * @param {!proto.api.DeleteDeviceAlarmRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.DeleteDeviceAlarmResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.DeleteDeviceAlarmResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.DeviceServiceClient.prototype.deleteDeviceAlarm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.DeviceService/DeleteDeviceAlarm',
      request,
      metadata || {},
      methodDescriptor_DeviceService_DeleteDeviceAlarm,
      callback);
};


/**
 * @param {!proto.api.DeleteDeviceAlarmRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.DeleteDeviceAlarmResponse>}
 *     Promise that resolves to the response
 */
proto.api.DeviceServicePromiseClient.prototype.deleteDeviceAlarm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.DeviceService/DeleteDeviceAlarm',
      request,
      metadata || {},
      methodDescriptor_DeviceService_DeleteDeviceAlarm);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.ReportServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.ReportServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListReportsRequest,
 *   !proto.api.ListReportsResponse>}
 */
const methodDescriptor_ReportService_ListReports = new grpc.web.MethodDescriptor(
  '/api.ReportService/ListReports',
  grpc.web.MethodType.UNARY,
  proto.api.ListReportsRequest,
  proto.api.ListReportsResponse,
  /**
   * @param {!proto.api.ListReportsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListReportsResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListReportsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListReportsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListReportsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.ReportServiceClient.prototype.listReports =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.ReportService/ListReports',
      request,
      metadata || {},
      methodDescriptor_ReportService_ListReports,
      callback);
};


/**
 * @param {!proto.api.ListReportsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListReportsResponse>}
 *     Promise that resolves to the response
 */
proto.api.ReportServicePromiseClient.prototype.listReports =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.ReportService/ListReports',
      request,
      metadata || {},
      methodDescriptor_ReportService_ListReports);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListUnreportedSystemsRequest,
 *   !proto.api.ListUnreportedSystemsResponse>}
 */
const methodDescriptor_ReportService_ListUnreportedSystems = new grpc.web.MethodDescriptor(
  '/api.ReportService/ListUnreportedSystems',
  grpc.web.MethodType.UNARY,
  proto.api.ListUnreportedSystemsRequest,
  proto.api.ListUnreportedSystemsResponse,
  /**
   * @param {!proto.api.ListUnreportedSystemsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListUnreportedSystemsResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListUnreportedSystemsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListUnreportedSystemsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListUnreportedSystemsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.ReportServiceClient.prototype.listUnreportedSystems =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.ReportService/ListUnreportedSystems',
      request,
      metadata || {},
      methodDescriptor_ReportService_ListUnreportedSystems,
      callback);
};


/**
 * @param {!proto.api.ListUnreportedSystemsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListUnreportedSystemsResponse>}
 *     Promise that resolves to the response
 */
proto.api.ReportServicePromiseClient.prototype.listUnreportedSystems =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.ReportService/ListUnreportedSystems',
      request,
      metadata || {},
      methodDescriptor_ReportService_ListUnreportedSystems);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.CallServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.CallServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListCallsConfigsRequest,
 *   !proto.api.ListCallsConfigsResponse>}
 */
const methodDescriptor_CallService_ListCallsConfigs = new grpc.web.MethodDescriptor(
  '/api.CallService/ListCallsConfigs',
  grpc.web.MethodType.UNARY,
  proto.api.ListCallsConfigsRequest,
  proto.api.ListCallsConfigsResponse,
  /**
   * @param {!proto.api.ListCallsConfigsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListCallsConfigsResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListCallsConfigsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListCallsConfigsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListCallsConfigsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.CallServiceClient.prototype.listCallsConfigs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.CallService/ListCallsConfigs',
      request,
      metadata || {},
      methodDescriptor_CallService_ListCallsConfigs,
      callback);
};


/**
 * @param {!proto.api.ListCallsConfigsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListCallsConfigsResponse>}
 *     Promise that resolves to the response
 */
proto.api.CallServicePromiseClient.prototype.listCallsConfigs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.CallService/ListCallsConfigs',
      request,
      metadata || {},
      methodDescriptor_CallService_ListCallsConfigs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.SaveCallConfigRequest,
 *   !proto.api.SaveCallConfigResponse>}
 */
const methodDescriptor_CallService_CreateCallConfig = new grpc.web.MethodDescriptor(
  '/api.CallService/CreateCallConfig',
  grpc.web.MethodType.UNARY,
  proto.api.SaveCallConfigRequest,
  proto.api.SaveCallConfigResponse,
  /**
   * @param {!proto.api.SaveCallConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.SaveCallConfigResponse.deserializeBinary
);


/**
 * @param {!proto.api.SaveCallConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.SaveCallConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.SaveCallConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.CallServiceClient.prototype.createCallConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.CallService/CreateCallConfig',
      request,
      metadata || {},
      methodDescriptor_CallService_CreateCallConfig,
      callback);
};


/**
 * @param {!proto.api.SaveCallConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.SaveCallConfigResponse>}
 *     Promise that resolves to the response
 */
proto.api.CallServicePromiseClient.prototype.createCallConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.CallService/CreateCallConfig',
      request,
      metadata || {},
      methodDescriptor_CallService_CreateCallConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.SaveCallConfigRequest,
 *   !proto.api.SaveCallConfigResponse>}
 */
const methodDescriptor_CallService_UpdateCallConfig = new grpc.web.MethodDescriptor(
  '/api.CallService/UpdateCallConfig',
  grpc.web.MethodType.UNARY,
  proto.api.SaveCallConfigRequest,
  proto.api.SaveCallConfigResponse,
  /**
   * @param {!proto.api.SaveCallConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.SaveCallConfigResponse.deserializeBinary
);


/**
 * @param {!proto.api.SaveCallConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.SaveCallConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.SaveCallConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.CallServiceClient.prototype.updateCallConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.CallService/UpdateCallConfig',
      request,
      metadata || {},
      methodDescriptor_CallService_UpdateCallConfig,
      callback);
};


/**
 * @param {!proto.api.SaveCallConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.SaveCallConfigResponse>}
 *     Promise that resolves to the response
 */
proto.api.CallServicePromiseClient.prototype.updateCallConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.CallService/UpdateCallConfig',
      request,
      metadata || {},
      methodDescriptor_CallService_UpdateCallConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.DeleteCallConfigRequest,
 *   !proto.api.DeleteCallConfigResponse>}
 */
const methodDescriptor_CallService_DeleteCallConfig = new grpc.web.MethodDescriptor(
  '/api.CallService/DeleteCallConfig',
  grpc.web.MethodType.UNARY,
  proto.api.DeleteCallConfigRequest,
  proto.api.DeleteCallConfigResponse,
  /**
   * @param {!proto.api.DeleteCallConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.DeleteCallConfigResponse.deserializeBinary
);


/**
 * @param {!proto.api.DeleteCallConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.DeleteCallConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.DeleteCallConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.CallServiceClient.prototype.deleteCallConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.CallService/DeleteCallConfig',
      request,
      metadata || {},
      methodDescriptor_CallService_DeleteCallConfig,
      callback);
};


/**
 * @param {!proto.api.DeleteCallConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.DeleteCallConfigResponse>}
 *     Promise that resolves to the response
 */
proto.api.CallServicePromiseClient.prototype.deleteCallConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.CallService/DeleteCallConfig',
      request,
      metadata || {},
      methodDescriptor_CallService_DeleteCallConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.GetCallConfigRequest,
 *   !proto.api.GetCallConfigResponse>}
 */
const methodDescriptor_CallService_GetCallConfig = new grpc.web.MethodDescriptor(
  '/api.CallService/GetCallConfig',
  grpc.web.MethodType.UNARY,
  proto.api.GetCallConfigRequest,
  proto.api.GetCallConfigResponse,
  /**
   * @param {!proto.api.GetCallConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.GetCallConfigResponse.deserializeBinary
);


/**
 * @param {!proto.api.GetCallConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.GetCallConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.GetCallConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.CallServiceClient.prototype.getCallConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.CallService/GetCallConfig',
      request,
      metadata || {},
      methodDescriptor_CallService_GetCallConfig,
      callback);
};


/**
 * @param {!proto.api.GetCallConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.GetCallConfigResponse>}
 *     Promise that resolves to the response
 */
proto.api.CallServicePromiseClient.prototype.getCallConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.CallService/GetCallConfig',
      request,
      metadata || {},
      methodDescriptor_CallService_GetCallConfig);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.PrefServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.PrefServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.UpdatePrefRequest,
 *   !proto.api.UpdatePrefResponse>}
 */
const methodDescriptor_PrefService_UpdatePref = new grpc.web.MethodDescriptor(
  '/api.PrefService/UpdatePref',
  grpc.web.MethodType.UNARY,
  proto.api.UpdatePrefRequest,
  proto.api.UpdatePrefResponse,
  /**
   * @param {!proto.api.UpdatePrefRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.UpdatePrefResponse.deserializeBinary
);


/**
 * @param {!proto.api.UpdatePrefRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.UpdatePrefResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.UpdatePrefResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.PrefServiceClient.prototype.updatePref =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.PrefService/UpdatePref',
      request,
      metadata || {},
      methodDescriptor_PrefService_UpdatePref,
      callback);
};


/**
 * @param {!proto.api.UpdatePrefRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.UpdatePrefResponse>}
 *     Promise that resolves to the response
 */
proto.api.PrefServicePromiseClient.prototype.updatePref =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.PrefService/UpdatePref',
      request,
      metadata || {},
      methodDescriptor_PrefService_UpdatePref);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.GetPrefRequest,
 *   !proto.api.GetPrefResponse>}
 */
const methodDescriptor_PrefService_GetPref = new grpc.web.MethodDescriptor(
  '/api.PrefService/GetPref',
  grpc.web.MethodType.UNARY,
  proto.api.GetPrefRequest,
  proto.api.GetPrefResponse,
  /**
   * @param {!proto.api.GetPrefRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.GetPrefResponse.deserializeBinary
);


/**
 * @param {!proto.api.GetPrefRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.GetPrefResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.GetPrefResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.PrefServiceClient.prototype.getPref =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.PrefService/GetPref',
      request,
      metadata || {},
      methodDescriptor_PrefService_GetPref,
      callback);
};


/**
 * @param {!proto.api.GetPrefRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.GetPrefResponse>}
 *     Promise that resolves to the response
 */
proto.api.PrefServicePromiseClient.prototype.getPref =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.PrefService/GetPref',
      request,
      metadata || {},
      methodDescriptor_PrefService_GetPref);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.MailServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.MailServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListDiscardedMailsRequest,
 *   !proto.api.ListDiscardedMailsResponse>}
 */
const methodDescriptor_MailService_ListDiscardedMails = new grpc.web.MethodDescriptor(
  '/api.MailService/ListDiscardedMails',
  grpc.web.MethodType.UNARY,
  proto.api.ListDiscardedMailsRequest,
  proto.api.ListDiscardedMailsResponse,
  /**
   * @param {!proto.api.ListDiscardedMailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListDiscardedMailsResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListDiscardedMailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListDiscardedMailsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListDiscardedMailsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.MailServiceClient.prototype.listDiscardedMails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.MailService/ListDiscardedMails',
      request,
      metadata || {},
      methodDescriptor_MailService_ListDiscardedMails,
      callback);
};


/**
 * @param {!proto.api.ListDiscardedMailsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListDiscardedMailsResponse>}
 *     Promise that resolves to the response
 */
proto.api.MailServicePromiseClient.prototype.listDiscardedMails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.MailService/ListDiscardedMails',
      request,
      metadata || {},
      methodDescriptor_MailService_ListDiscardedMails);
};


module.exports = proto.api;

